module.exports = {
      id: "text-usage",
      viewBox: "0 0 18.361 15.287",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#text",
      toString: function () {
        return this.url;
      }
    }